import isPrimaryCountry from "@/helpers/locations/primaryCountry";

const isAllStatesOfPrimaryCountry = (countries: string[]) => {
  if (countries.length === 0 || countries.length > 2) {
    return false;
  }

  return countries.every(isPrimaryCountry);
}

export default isAllStatesOfPrimaryCountry;